import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { http } from "../../common/lib";
import config from "../../config";
import { actionCreators, actionTypes } from "./actions";
import i18next from "../../common/i18n";
import { logToSentry } from "../../config/Sentry";


function* post(action) {
    const { detail } = action.payload;
    try {
        yield call(http.authorized.post, config.api.paths.userLanguage, detail);
        yield put(actionCreators.postSuccess());
    } catch (error) {
        const errStr = error.toString();
        logToSentry("On user language post:", { error });
        yield all([
            put(actionCreators.postFailure(errStr)),
            put(toastActions.error(i18next.t("errors.languageChangePost")))
        ]);
    }
}

export { post };

export default function* () {
    yield all([takeLatest(actionTypes.USER_LANGUAGE_POST_REQUEST, post)]);
}
